import * as types from '../mutation_types';
import axios from '@node_modules/axios';


export default {
  async setCurrentPage({ commit, state, rootState }, page){
    try{
      commit(types.SET_SDG_CURRENT_PAGE, page);
    }catch(err){
      throw err
    }
  },
  async loadItems({ commit, state, rootState }, url){
    try{
      let response = await axios.get(typeof(url) === 'string' ? url : rootState.api.sdgProjects)
      commit(types.SET_SDG_PROJECTS, response.data.results);
      commit(types.SET_SDG_COUNT, response.data.count);
      commit(types.SET_SDG_PREV, response.data.previous);
      commit(types.SET_SDG_NEXT, response.data.next);
      commit(types.SET_SDG_RAISED, response.data.fund_raised);
      commit(types.SET_SDG_NUM_PROJECTS, response.data.num_projects);
      commit(types.SET_SDG_IDENTIFIER, response.data.sdg_identifier);
      commit(types.SET_SDG_COMMUNITY, response.data.community);
    }catch(err){
      throw err;
    }
  }
};
